// 3rd party services
import ZendeskChatbotService from './third-party-service/zendesk'
import DummyChatbotService from './third-party-service/dummy'
// Chatbot service. The design pattern "Strategy". It allows us to use different 3rd party services
import ChatbotService from './service'
// Constants. Mapping the service name with the name inside BE
import CHATBOT from '@/constants/chatbot'

const CHATBOT_SERVICE_MAPPING = {
  [CHATBOT.zendesk]: ZendeskChatbotService,
}

const get3rdPartyChatbotServiceName = async (locator) => {
  const config = await locator.store.dispatch(
    'configuration/fetchGlobalConfiguration'
  )
  const { chatbotServiceProvider = '' } = config || {}

  if (!chatbotServiceProvider) {
    return ''
  }

  if (Object.values(CHATBOT).includes(chatbotServiceProvider)) {
    return chatbotServiceProvider
  }

  return ''
}

const get3rdPartyChatbotServiceInstance = async (locator) => {
  const chatbotServiceName = await get3rdPartyChatbotServiceName(locator)

  if (!chatbotServiceName) {
    return new DummyChatbotService()
  }

  const ChatbotService = CHATBOT_SERVICE_MAPPING[chatbotServiceName]

  return new ChatbotService()
}

const buildChatBotService = async (locator) => {
  let chatbotService3rdPartyInstance = await get3rdPartyChatbotServiceInstance(
    locator
  )

  // Don't call 3rd service if it is not available
  if (!chatbotService3rdPartyInstance.isAvailable()) {
    chatbotService3rdPartyInstance = new DummyChatbotService()
  }

  const instance = new ChatbotService(chatbotService3rdPartyInstance)

  locator.chatbot = instance

  // Return the instance of the service to use directly. We can use locator.chatbot to access the service
  return instance
}

export { buildChatBotService }
